import { AuthGuard } from "@dis/auth";
import { CollectionSelectionService } from "../layout/collection-detail-layout/collection-selection.service";
import { provideDetailLinks } from "../layout/collection-detail-layout/detail-links.service";
import { JtmsRoutes, collectionDetailLayout, tablesLayout, groupOverview } from "../core/routing/route-data";

export default [
  {
    path: "",
    canMatch: [AuthGuard],
    data: { navGroup: "sales" },
    children: [
      groupOverview(() => import("../feature/overviews/sales-overview").then((m) => m.SalesOverview)),
      {
        path: "leads",
        children: [
          {
            path: "",
            pathMatch: "full",
            loadComponent: tablesLayout,
            children: [
              {
                path: "",
                data: { navOrder: 1 },
                loadComponent: () => import("../feature/tables/leads/leads-table.component").then((m) => m.LeadsTable),
                title: "Leads",
              },
            ],
          },
          {
            // LeadGetById takes $id; the container maps the leadId input to it.
            path: ":leadId",
            providers: [CollectionSelectionService, provideDetailLinks("entity")],
            loadComponent: collectionDetailLayout,
            children: [
              {
                path: "",
                loadComponent: () =>
                  import("../feature/dashboards/collection-detail/views/lead-detail-view-container/lead-detail-view-container.component").then(
                    (m) => m.LeadDetailViewContainer
                  ),
                title: "Lead Details",
              },
            ],
          },
        ],
      },
      {
        path: "quotes",
        children: [
          {
            path: "",
            pathMatch: "full",
            loadComponent: tablesLayout,
            children: [
              {
                path: "",
                data: { navOrder: 2 },
                loadComponent: () =>
                  import("../feature/tables/quotes/quotes-table.component").then((m) => m.QuotesTable),
                title: "Quotes",
              },
            ],
          },
          {
            path: "files",
            loadComponent: () =>
              import("../feature/quotes/quotes-file-table/quotes-file-table.component").then((m) => m.QuotesFileTable),
            title: "Quote Files",
          },
        ],
      },
      {
        path: "customers",
        loadComponent: tablesLayout,
        children: [
          {
            path: "",
            data: { navOrder: 3 },
            loadComponent: () =>
              import("../feature/customers/customers-ag-grid/customers-ag-grid").then((m) => m.CustomersAgGrid),
            title: "Customers",
          },
        ],
      },
      {
        path: "reports/customer-projects",
        data: { navOrder: 4, report: true, reportOwner: "sales" },
        loadComponent: () => import("../feature/dashboards/customer-kpi/customer-kpi").then((m) => m.CustomerKpi),
        title: "Customer Projects",
      },
    ],
  },
] satisfies JtmsRoutes;
